import { Image } from '@smartgift/frontend-toolkit';
import { useTheme } from 'styled-components';

import { ProductGallery } from '@hero/molecules';

import * as S from './style';

function ProductDetailImage({ product, images, setSwiperRef = () => {} }) {
  const theme = useTheme();

  return !images?.length ? (
    <S.ProductImageWrapper>
      <Image src={theme.images.noImage} width="100%" />
    </S.ProductImageWrapper>
  ) : images?.length === 1 ? (
    <S.ProductImageWrapper>
      <Image src={images[0].url} alt={product.name} width="100%" />
    </S.ProductImageWrapper>
  ) : (
    <ProductGallery setSwiperRef={setSwiperRef} images={images} />
  );
}

export { ProductDetailImage };
